const template = document.querySelector('.smart-host-template');

if (template) {
    window.addEventListener(
        'CookiebotOnAccept', () => {
            const parent = template.parentNode;

            if (!parent) {
                return;
            }

            const clone = template.content.cloneNode(true);

            const iframe = clone.querySelector('.sh-container').parentNode;

            if (iframe) {
                parent.appendChild(iframe);
            }
        }
    );
}
